import api from "@/services/api";
import {
  DashboardSignatureStatsParams,
  DashboardSignatureStatsResponse,
} from "@/interfaces/DashboardSignatureStats";

export const dashboardSignatureStatsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDashboardSignatureStats: build.query<
      DashboardSignatureStatsResponse,
      DashboardSignatureStatsParams
    >({
      query: (params) => ({
        url: "/admin/stats/signatures",
        params,
      }),
      providesTags: [{ type: "DashboardStats", id: "SIGNATURES" }],
    }),
  }),
  overrideExisting: true,
});

export const { useGetDashboardSignatureStatsQuery } =
  dashboardSignatureStatsApi;
